import PropTypes from "prop-types";
import {
  generateImageSources,
  DESKTOP_MEDIA_QUERY,
} from "./generateImageSources";
import styles from "./index.css";

const CategoryHeaderImage = ({ featuredHeaderData }) => {
  const { mobile, desktop } = generateImageSources(featuredHeaderData);
  // Either asset can be absent from the CMS; fall back rather than render an
  // <img> with no src.
  const fallback = mobile || desktop;

  return (
    <div className={styles.categoryHeaderImage}>
      <picture>
        {desktop && (
          <source
            media={DESKTOP_MEDIA_QUERY}
            srcSet={desktop.srcSet || desktop.src}
            sizes="100vw"
          />
        )}
        <img
          alt=""
          className={styles.image}
          decoding="async"
          sizes="100vw"
          src={fallback?.src}
          srcSet={fallback?.srcSet}
          // React 17 drops the camelCase form; spread as ProductImage does.
          {...{ fetchpriority: "high" }}
        />
      </picture>
    </div>
  );
};

CategoryHeaderImage.propTypes = {
  featuredHeaderData: PropTypes.shape({
    app: PropTypes.shape({
      imageUrl: PropTypes.string,
      videoAssetId: PropTypes.string,
    }),
    displayText: PropTypes.string,
    isEnabled: PropTypes.bool,
    web: PropTypes.shape({
      imageUrl: PropTypes.string,
      videoAssetId: PropTypes.string,
    }),
  }),
};

export default CategoryHeaderImage;
